<div role="button"
  [style]="qBank._id == currentQBank?._id ? 'rgba:34, 33, 54, 0.6; border-right: 5px solid rgb(112, 112, 177); color: white; border-radius:8px;' : '' "
  class="show-count d-flex align-items-center justify-content-between survery-hover p-3"
  *ngFor="let qBank of questionBanks">
  <span class="w-100" [ngClass]="{'type-bg': qBank._id == currentQBank?._id}" (click)="changeCurrentQBank(qBank)">
    {{qBank.name}} <br> ({{ qBank.tag.arabic }})
  </span>
  <span (click)="changeCurrentQBank(qBank)" class="questionbank-count"></span>
  <span class="question-count">
    <p-menu #menu
      [model]="(qBank._id == standardQBID || qBank._id == '65be1be32d7710d9e377d543')? updateOnlyMenuItem: hasCreatedBy(qBank)"
      [popup]="true" appendTo="body"></p-menu>
    <p-button class="v4-ui" *ngIf="qBank._id == standardQBID ? hasPermission('GENERAL_QB','a') : true"
      styleClass="p-button-rounded p-button-text" (onClick)="openTypeMenu(menu,$event,qBank)"
      icon="pi pi-ellipsis-v"></p-button>
  </span>
</div>

<div (click)="openCreateModal = true" role="button" class="input-option">
  <i class="pi pi-plus-circle mx-2"></i> {{ "Add Question Bank" | translator }}
</div>

<!-- Update Data Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="updateModal"
  [style]="{ margin: '0rem 1rem' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{
      "Update Question Bank" | translator
      }}</span>
  </ng-template>
  <app-dynamic-form *ngIf="updateModal" [questions]="updateQuestions"
    (sendData)="UpdateData($event)"></app-dynamic-form>
</p-dialog>

<!-- Create new Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openCreateModal"
  [style]="{ margin: '0rem 1rem',width:'40%' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{"Add Question Bank"| translator}}</span>
  </ng-template>
  <app-dynamic-form [questions]="questions" (sendData)="receiveData($event)"></app-dynamic-form>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openInfoModal"
  [style]="{ margin: '0rem 1rem', width: '45vw', maxWidth: '1000px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Created By Info" | translator }}</span>
  </ng-template>
  <div class="d-flex gap-1">
    <div>
      <h5 class="medium-h">{{ "Created By Name" | translator }}</h5>
      <input
        type="text"
        [value]="getName(createdInfo?.createdBy?.name)"
        class="p-inputtext"
        [disabled]="true"
      />
    </div>
    <div>
      <h5 class="medium-h">{{ "Created By Email" | translator }}</h5>
      <input
        type="text"
        [value]="createdInfo?.createdBy?.email"
        class="p-inputtext"
        [disabled]="true"
      />
    </div>
    <div>
      <h5 class="medium-h">{{ "Created Time" | translator }}</h5>
      <input
        type="text"
        [value]="createdInfo?.createdAt | date: 'medium'"
        class="p-inputtext"
        [disabled]="true"
      />
    </div>
  </div>
</p-dialog>